// One DOM update per animation frame; scrolling must not re-render cards or translations.
export function attachHeroParallax(element: HTMLElement, browser: Window) {
  const motion = browser.matchMedia('(prefers-reduced-motion: reduce)');
  let frame: number | null = null;
  let lastOffset = '';
  const update = () => {
    frame = null;
    const bounds = element.getBoundingClientRect();
    if (!motion.matches && (bounds.bottom < 0 || bounds.top > browser.innerHeight)) return;
    const progress = Math.max(0, Math.min(1, -bounds.top / Math.max(1, browser.innerHeight)));
    const offset = motion.matches ? '0px' : `${Math.round(progress * -450)}px`;
    if (offset !== lastOffset) {
      element.style.setProperty('--hero-parallax-y', offset);
      lastOffset = offset;
    }
  };
  const schedule = () => {
    if (frame === null) frame = browser.requestAnimationFrame(update);
  };
  const onScroll = () => {
    if (!motion.matches) schedule();
  };
  browser.addEventListener('scroll', onScroll, { passive: true });
  browser.addEventListener('resize', schedule, { passive: true });
  motion.addEventListener('change', schedule);
  schedule();
  return () => {
    if (frame !== null) browser.cancelAnimationFrame(frame);
    browser.removeEventListener('scroll', onScroll);
    browser.removeEventListener('resize', schedule);
    motion.removeEventListener('change', schedule);
    element.style.removeProperty('--hero-parallax-y');
  };
}
